export default class Loader {
   static showLoader(flightsReducer) {
       return (flightsReducer.flights.length === 0 && flightsReducer.loading
           || (flightsReducer.loading && !flightsReducer.cachedResults))
           && !flightsReducer.hadResults;
   }
}




// WEBPACK FOOTER //
// ./src/helpers/Loader.js